import type { ChangeEvent } from 'react'
import { maskNationalPhone, nationalDigits } from '../model'

export interface PhoneFieldProps {
  id: string
  describedBy: string | undefined
  value: string
  placeholder: string
  onChange: (digits: string) => void
  onSubmit: () => void
  autoFocus?: boolean
}

/**
 * Префикс +998 нарисован, а не введён: страна одна, и лишние символы в поле
 * только мешают попасть пальцем. Наружу отдаём чистые цифры.
 */
export function PhoneField({
  id,
  describedBy,
  value,
  placeholder,
  onChange,
  onSubmit,
  autoFocus = false,
}: PhoneFieldProps) {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(nationalDigits(event.target.value))
  }

  return (
    <div className="phone-field">
      <span className="pref" aria-hidden="true">
        +998
      </span>
      <input
        id={id}

        // Цифровая клавиатура и автоподстановка своего номера — как в нативном.
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        enterKeyHint="go"
        // Единственное поле экрана входа: клавиатура обязана открыться сразу,
        // как в нативном приложении. Фокус ни у кого не отнимается.
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        placeholder={placeholder}
        aria-describedby={describedBy}
        value={maskNationalPhone(value)}
        onChange={handleChange}
        onKeyDown={(event) => {
          if (event.key === 'Enter') onSubmit()
        }}
      />
    </div>
  )
}
